import React from 'react';
import DoubleDropdownComponent from '../../components/Filters/doubleDropdown';
class ScheduleSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            schedulesJSON: [
                {
                    initScheduleId: -1,
                    endScheduleId: -1,
                    initSchedule: '',
                    endSchedule: '',
                }
            ],
            showDelete: false
        }
        this.handleChangeInitPeriod = this.handleChangeInitPeriod.bind(this);
        this.handleChangeEndPeriod = this.handleChangeEndPeriod.bind(this);
        this.addNewScheduleSelector = this.addNewScheduleSelector.bind(this);
        this.removeScheduleSelector = this.removeScheduleSelector.bind(this);
    }

    addNewScheduleSelector(){
        const { id, name, updateFiltersMessage } = this.props
        const { schedulesJSON } = this.state
        var newSchedulesJSON = schedulesJSON
        newSchedulesJSON.push(
            {
                initScheduleId: -1,
                endScheduleId: -1,
                initSchedule: '',
                endSchedule: '',
            }
        )
        this.setState({
            schedulesJSON: newSchedulesJSON,
            showDelete: true
        });
        const message = {
            id: id,
            name: name,
            parameters: ''
        }
        updateFiltersMessage(message);
    }

    removeScheduleSelector(index){
        const { schedulesJSON } = this.state
        if(schedulesJSON.length == 1){
            return
        }
        var newSchedulesJSON = schedulesJSON
        newSchedulesJSON.splice(index, 1)

        var newShowDelete = true
        if(newSchedulesJSON.length == 1){
            newShowDelete = false
        }

        this.setState({
            schedulesJSON: newSchedulesJSON,
            showDelete: newShowDelete
        });
        this.checkStateAndPushParams(newSchedulesJSON)
    }

    resetFilterMessage(){
        const { id, name, updateFiltersMessage } = this.props;
        const message = {
            id: id,
            name: name,
            parameters: ''
        }
        updateFiltersMessage(message);
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.data !== this.props.data) || (prevProps.filters !== this.props.filters)) {
            this.setState({
                schedulesJSON: [
                    {
                        initScheduleId: -1,
                        endScheduleId: -1,
                        initSchedule: '',
                        endSchedule: '',
                    }
                ],
                showDelete: false
            });
            this.resetFilterMessage();
        }
    }


    checkStateAndPushParams(schedulesJSON){
        const { id, name, updateFiltersMessage } = this.props
        //validate if all menus are setup
        var dataIsValid = true
        var filterScheduleData;
        for (var i = 0; i < schedulesJSON.length; i++) {
            filterScheduleData = schedulesJSON[i]
            if((filterScheduleData["initScheduleId"] == -1) || (filterScheduleData["endScheduleId"]  == -1)) {
                dataIsValid = false
                break;
            }
        }
        if(dataIsValid == true) {
            var parametersArray = [];
            var parameters = '';
            for (var i = 0; i < schedulesJSON.length; i++) {
                filterScheduleData = schedulesJSON[i]
                parametersArray.push(
                    '<parameter>',
                    '<id>',
                    filterScheduleData["initScheduleId"],
                    '</id>',
                    '<name>',
                    filterScheduleData["initSchedule"],
                    '</name>',
                    '</parameter>',
                    '<parameter>',
                    '<id>',
                    filterScheduleData["endScheduleId"],
                    '</id>',
                    '<name>',
                    filterScheduleData["endSchedule"],
                    '</name>',
                    '</parameter>'
                )
            }
            parameters = parametersArray.join('');
            const message = {
                id: id,
                name: name,
                parameters: parameters
            }
            updateFiltersMessage(message);
        }
    }

    handleChangeInitPeriod(e) {
        const { id, name, updateFiltersMessage, data } = this.props
        const { schedulesJSON } = this.state
        const selectedInitSchedule = e.target.value.dataValue
        const arrayIndex = e.target.value.arrayId

        var filterScheduleData = schedulesJSON[arrayIndex]
        var newSchedulesJSON = schedulesJSON

        var selectedInitScheduleId;
        data.map(dataItem => {
            if (dataItem.name === selectedInitSchedule) {
                selectedInitScheduleId = parseInt(dataItem.id)
            }
        });

        //check if we need to move the ending schedule
        var tempEndScheduleId = filterScheduleData["endScheduleId"];
        var tempEndSchedule = filterScheduleData["endSchedule"];
        if((tempEndScheduleId < selectedInitScheduleId) && (tempEndScheduleId !== -1)){
            tempEndScheduleId = selectedInitScheduleId;
            tempEndSchedule = selectedInitSchedule;
        }
  
        filterScheduleData["initScheduleId"] = selectedInitScheduleId
        filterScheduleData["endScheduleId"] = tempEndScheduleId
        filterScheduleData["initSchedule"] = selectedInitSchedule
        filterScheduleData["endSchedule"] = tempEndSchedule

        newSchedulesJSON[arrayIndex] = filterScheduleData

        this.setState({
            schedulesJSON: newSchedulesJSON,
        });
        this.checkStateAndPushParams(newSchedulesJSON)
    };

    handleChangeEndPeriod(e) {
        const { id, name, updateFiltersMessage, data } = this.props;
        const { schedulesJSON } = this.state;
        const selectedEndSchedule=e.target.value.dataValue;
        const arrayIndex = e.target.value.arrayId

        var filterScheduleData = schedulesJSON[arrayIndex]
        var newSchedulesJSON = schedulesJSON

        var selectedEndScheduleId;
        data.map(dataItem => {
            if (dataItem.name === selectedEndSchedule) {
                selectedEndScheduleId = parseInt(dataItem.id)
            }
        });

        //check if we need to move the ending schedule
        var tempInitScheduleId = filterScheduleData["initScheduleId"];
        var tempInitSchedule = filterScheduleData["initSchedule"];
        if((tempInitScheduleId > selectedEndScheduleId) && (tempInitScheduleId !== -1)){
            tempInitScheduleId = selectedEndScheduleId;
            tempInitSchedule = selectedEndSchedule;
        }

        filterScheduleData["initScheduleId"] = tempInitScheduleId
        filterScheduleData["endScheduleId"] = selectedEndScheduleId
        filterScheduleData["initSchedule"] = tempInitSchedule
        filterScheduleData["endSchedule"] = selectedEndSchedule

        newSchedulesJSON[arrayIndex] = filterScheduleData

        this.setState({
            schedulesJSON: newSchedulesJSON,
        });
        this.checkStateAndPushParams(newSchedulesJSON)
    };

    render() {
        const { schedulesJSON, showDelete } = this.state;
        const { data, required } = this.props;

        var dropDownArray = []
        var fileterData
        for (var i = 0; i < schedulesJSON.length; i++) {
            fileterData = schedulesJSON[i]
            dropDownArray.push(
                <DoubleDropdownComponent
                    arrayId={i}
                    initSchedule={fileterData.initSchedule}
                    endSchedule={fileterData.endSchedule}
                    data={data}
                    required={required}
                    showDelete={showDelete}
                    handleChangeInitPeriod={this.handleChangeInitPeriod}
                    handleChangeEndPeriod={this.handleChangeEndPeriod}
                    addNewScheduleSelector={this.addNewScheduleSelector}
                    removeScheduleSelector={this.removeScheduleSelector}
                />
            )
        }
        return (
            <div>
                {dropDownArray}
            </div>
        )
    }
}

export default ScheduleSelector;